import Resource from '@/api/Resource';
import TestSession from '@/models/TestSession';
import api from '@/api';

export default class Answer extends Resource {
  $name = 'users-answers';

  $defaults() {
    return {
      test_question_id: null,
      test_session_id: null,
      answer: null,
      input: '',
      correct: null,
    };
  }

  $fill({ session }) {
    if (session) {
      this.session = new TestSession(session);
    }
  }

  $save() {
    return api
      .for(`questions/${this.test_question_id}/sessions/${this.test_session_id}/answer`)
      .request('patch', null, {
        data: {
          correct: this.correct,
        },
      });
  }
}
